import { useLocation } from "react-router";

import { useCloseRoutedForm } from "../misc/useMobileFormGuard";
import { ContactListMobile } from "./ContactList";
import { ContactCreateSheet } from "./ContactCreateSheet";

/**
 * /contacts/create on a phone (e.g. "Add contact" on a company page): the
 * create sheet over the contact list. Back or the x leaves the route.
 */
export const ContactCreateMobile = () => {
  const location = useLocation();
  const close = useCloseRoutedForm("/contacts");
  const record = (location.state as { record?: Record<string, unknown> })
    ?.record;
  return (
    <>
      <ContactListMobile />
      <ContactCreateSheet
        open
        onOpenChange={(open) => {
          if (!open) close();
        }}
        defaultValues={record}
        history={false}
      />
    </>
  );
};
